export class LogicEvents {
    public static readonly INIT_RESPONSE: symbol = Symbol('INIT_RESPONSE');
    public static readonly SPIN_RESPONSE: symbol = Symbol('SPIN_RESPONSE');
    public static readonly FREE_SPIN_RESPONSE: symbol = Symbol('FREE_SPIN_RESPONSE');
    public static readonly RESPIN_RESPONSE: symbol = Symbol('RESPIN_RESPONSE');
    public static readonly MINI_SPIN_RESPONSE: symbol = Symbol('MINI_SPIN_RESPONSE');
    public static readonly BUY_RESPONSE: symbol = Symbol('BUY_RESPONSE');
    public static readonly PICK_RESPONSE: symbol = Symbol('PICK_RESPONSE');
    public static readonly SELECT_RESPONSE: symbol = Symbol('SELECT_RESPONSE');
    public static readonly RESPONSE: symbol = Symbol('RESPONSE');
    public static readonly PROGRESSIVE_RESPONSE: symbol = Symbol('PROGRESSIVE_RESPONSE');
    public static readonly CONNECTION_ERROR: symbol = Symbol('CONNECTION_ERROR');
    public static readonly GAME_UNAVAILABLE: symbol = Symbol('GAME_UNAVAILABLE');
    public static readonly GAMESERVER_ERROR: symbol = Symbol('GAMESERVER_ERROR');
    public static readonly INVALID_BALANCE: symbol = Symbol('INVALID_BALANCE');
    public static readonly BALANCE_UPDATED: symbol = Symbol('BALANCE_UPDATED');
    public static readonly CONNECTION_TIMEOUT: symbol = Symbol('CONNECTION_TIMEOUT');
    public static readonly CONNECTION_SLOW: symbol = Symbol('CONNECTION_SLOW');
    public static readonly REALITY_CHECK: symbol = Symbol('REALITY_CHECK');
    public static readonly PLACE_BET_ERROR: symbol = Symbol('PLACE_BET_ERROR');
    public static readonly TEMPORARY_ERROR: symbol = Symbol('TEMPORARY_ERROR');
    public static readonly ROUND_START: symbol = Symbol('LogicEvents.ROUND_START');
    public static readonly ROUND_STARTED: symbol = Symbol('LogicEvents.ROUND_STARTED');
    public static readonly BET_CHANGED: symbol = Symbol('LogicEvents.BET_CHANGED');
    public static readonly POINTS_BALANCE_UPDATED: symbol = Symbol('LogicEvents.POINTS_BALANCE_UPDATED');
}
